/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSign.vue?vue&type=template&id=e550a762&scoped=true"
import script from "./popSign.vue?vue&type=script&lang=js"
export * from "./popSign.vue?vue&type=script&lang=js"
import style0 from "./popSign.vue?vue&type=style&index=0&id=e550a762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e550a762",
  null
  
)

export default component.exports